/*
 * @Author: Vanny
 * @Date: 2019-10-23 16:50:24
 * @LastEditors: Vanny
 * @LastEditTime: 2020-04-29 17:22:56
 * @Description: 通用方法
 */
import * as Sentry from '@sentry/browser'
import { nativeInteract } from '@duoke/tools'

const NativeFuncs = {
  NAVIGATION: {
    CUSTOMER_SERVICE: {
      ns: 'navigation',
      fn: 'customerService',
    },
    GENERAL: {
      ns: 'navigation',
      fn: 'general',
    },
  },
  SYSTEM: {
    USER_DATA: {
      ns: 'system',
      fn: 'userData',
    },
    STATUS_BAR_STYLE: {
      ns: 'system',
      fn: 'statusBarStyle',
    },
    OPEN_WINDOW: {
      ns: 'system',
      fn: 'openWindow',
    },
    CLOSE: {
      ns: 'system',
      fn: 'close',
    },
  },
  ALERT: {
    SHARE: {
      ns: 'alert',
      fn: 'share',
    },
  },
  CMS: {
    RENEWAL_FEE: {
      ns: 'navigation',
      fn: 'renewal',
    },
    STORE_SHOP: {
      ns: 'navigation',
      fn: 'storeShopWarehouse',
    },
    BHB_OPEN: {
      ns: 'navigation',
      fn: 'replenishmentPro',
    },
  },
}

// 传 NativeFuncs 有利于开发测试
export default nativeInteract({
  env: process.env,
  win: window,
  Sentry,
  NativeFuncs,
})

export const isMC = () => process.env.APP_TYPE === 'mc'

export const isDev = () => process.env.NODE_ENV === 'development'



// WEBPACK FOOTER //
// ./src/utils/index.js